import type { FaireProductEntity } from "../../entity_types/product";

export const p_ugemt4pwz7: FaireProductEntity = {
  token: "p_ugemt4pwz7",
  type: "product",
  name: "Girl Dad Gym Crew Socks",
  brandToken: "b_1fc44661",
  brandName: "Gumball Poodle",
  imageUrl: "https://cdn.faire.com/fastly/93444e738bee7436ca5e3409f1dd8c2937e98d5c3252cbdae856757350ad88fe.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/207911442a49b7e023d5c3fc58792a03ac9807ea5af4b95e81c9efa480f00321.jpeg",
    "https://cdn.faire.com/fastly/074a2c208990f795ddec53ac639d67ba80fd08b4676f335ac23e680ad75e4f98.jpeg",
    "https://cdn.faire.com/fastly/e905299ebf60a9a716c18bd0d111c686e98f2685ae50ec17f954482488815cd4.jpeg",
    "https://cdn.faire.com/fastly/8bb4cbc732259c83dd75e3c2a914f2d557643aad93efdbac470e15550122943b.jpeg",
    "https://cdn.faire.com/fastly/d1802bbc65e3a066fc034b544deb512e9e90f25168c672b13c03b6b87329f860.jpeg",
    "https://cdn.faire.com/fastly/333d22d787fc94a7883d0ced4ce57edfedc08246a2d5dc76ac33624d0181679c.jpeg"
  ],
  priceDollars: 6.75,
  description: "These socks are for the dad that is outnumbered, outsmarted, and loving every minute of it.\n\nGumball Poodle is GPSR compliant! We will automatically be stickering all orders into the EU or Northern Ireland for GPSR compliance. \n\nIf you are in the UK but sell into the EU, we can provide you with the necessary stickers to put on products - be sure to tell us you need these when you place your order.",
  tags: [],
  msrpDollars: 14,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-10-12T05:33:22.614Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
